export const FREE_PLAN = 'FREE';

export interface PaymentErrorMessage {
    [errorCode: string]: string;
}
